// extracted by mini-css-extract-plugin
module.exports = {"option":"AfterDeliveryOptions_option__ZdC4e"};